import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import RestaurantDetail from './pages/RestaurantDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import MyReservations from './pages/MyReservations';
import MyProfile from './pages/MyProfile';
import ForgotPassword from './pages/ForgotPassword';
import VerifyResetOtp from './pages/VerifyResetOtp';
import ResetPassword from './pages/ResetPassword';
import RateReservation from './pages/RateReservation';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import GuestPayment from './pages/GuestPayment';
import GuestPaymentSuccess from './pages/GuestPaymentSuccess';
import ReservationWidget from './pages/ReservationWidget';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/restaurant/:id" element={<RestaurantDetail />} />
        <Route path="/widget" element={<ReservationWidget />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/my-reservations" element={<MyReservations />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/rate/:reservationId" element={<RateReservation />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/pay/:token" element={<GuestPayment />} />
        <Route path="/guest-payment-success" element={<GuestPaymentSuccess />} />
      </Routes>
    </Router>
  );
}

export default App;
